import React, { FC, useCallback, useState } from 'react';
import {
    overviewMarketsOrdered$$,
    isSportSwitchAllowedMarket$$,
    overviewMarket$$,
    selectedMarketIds$$,
    sportMaxColumns$$
} from '../push/overview/subs';
import { localizeMap } from '../utils';
import useMediaColsCount from '../hooks/useMediaColsCount';
import { openDialogOptions } from '../config';
import { useReframe } from 'nike-re-framejs';
import CustomSelectBox, { DropDown, DropDownOption } from '../../forms/CustomSelectBox';
import clsx from 'clsx';
import { useMatchMedia } from '../hooks/useMatchMedia';
import i18n from '../../../common/i18n';
import { isMobileChannel } from '../../../common/util';

export const MarketSelection: FC<{
    marketId: string;
    columnId: number;
    sportName: string;
    onSelect: (marketId: string) => void;
    saveFavouritePopup?: boolean;
}> = ({ marketId, columnId, sportName, onSelect, saveFavouritePopup = false }) => {
    const derefSub = useReframe();
    const market = derefSub(overviewMarket$$(sportName, marketId));

    const marketName = localizeMap(market?.get('name'));
    const sportMaxCols = derefSub(sportMaxColumns$$(sportName));
    const maxMediaCols = useMediaColsCount();
    const maxCols = Math.min(sportMaxCols, maxMediaCols);
    const markets = derefSub(overviewMarketsOrdered$$(sportName));
    const selectedMarketIds = derefSub(selectedMarketIds$$(sportName));
    const matchMedia = useMatchMedia();
    const selectedMarkets = selectedMarketIds
        ?.take(maxCols)
        .map(selectedMarketId => markets.get(String(selectedMarketId)));
    const marketsOrderedBySelection = selectedMarkets
        .concat(markets.filter(market => !selectedMarketIds.take(maxCols).includes(market.get('id'))).values())
        .filter(market => market);
    function onSelectionClick() {
        if (isSwitchAllowed) {
            if (isMobileChannel()) {
                openDialogOptions(marketsOrderedBySelection, onSelect, market);
            }
        }
    }
    const onSelectMarket = market => {
        onSelect(market.get('id'));
    };
    const isSwitchAllowed = derefSub(isSportSwitchAllowedMarket$$(sportName, columnId));

    //this is one of the newest magic in my collection, computes max width of dropDown element based on position of dropDown on screen, to avoid overflowing right,
    //this time we take 'turbo-live-last' element which is already rendered for sure, compute it's position on screen, and compute position of dropDown on screen after it is rendered
    //then get difference between their x position and add width of 'turbo-live-last' (should be always 72, but just to be sure)
    // then we send this width to dropDown element, where we set it's style width to computed width, or 320, which is default
    //I hope nobody will notice this black dark sh*t ;) but it's kinda working ?
    const [width, setWidth] = useState(320);
    const dropDownRef = useCallback(node => {
        if (node) {
            let computedWidth;
            const lastNode = document.getElementsByClassName('turbo-live-last')[0];
            if (lastNode) {
                const lastNodeRect = lastNode.getBoundingClientRect();
                computedWidth = lastNodeRect.x - node.getBoundingClientRect().x + lastNodeRect.width - 20;
            } else {
                computedWidth = node.parentNode.offsetWidth + 10;
            }
            setWidth(computedWidth > 320 ? 320 : computedWidth);
        }
    }, []);
    if (!market) {
        return null;
    }

    return (
        <div className={clsx('mx-5', matchMedia.xxl || isMobileChannel() ? 'mt-10' : 'mt-5')}>
            <CustomSelectBox
                label={
                    saveFavouritePopup && `${i18n('nui.turbo.live.saveMarketsDialog.selectionHeader')} ${columnId + 1}`
                }
                formLikeView={saveFavouritePopup}
                selectedItem={marketName}
                dropDownShort={saveFavouritePopup}
                onClick={onSelectionClick}
                isMobile={isMobileChannel()}
                disabled={!isSwitchAllowed}
            >
                <DropDown
                    small={saveFavouritePopup}
                    dropDownRef={dropDownRef}
                    width={saveFavouritePopup ? null : width}
                    formView={saveFavouritePopup}
                >
                    {marketsOrderedBySelection
                        ?.map((market, i) => {
                            const selection = (
                                <div className="flex full-width">
                                    {maxCols > 1 && (
                                        <span className="market-selection-position text-extra-bold">
                                            {i < maxCols ? i + 1 : ''}
                                        </span>
                                    )}

                                    <span>{localizeMap(market.get('name'))}</span>
                                </div>
                            );
                            return (
                                <DropDownOption
                                    key={market.get('id') + i}
                                    option={selection}
                                    onSelect={() => onSelectMarket(market)}
                                    className={'py-5 px-10'}
                                />
                            );
                        })
                        .toArray()}
                </DropDown>
            </CustomSelectBox>
        </div>
    );
};
